import './styles/basic.css';
import './styles/utils.css';
import './styles/effects.css';
import './styles/woah.css';
import { BrowserRouter, Route, Routes } from 'react-router';
import { Gouch } from './components/Gouch';
import { BowliversWorld } from './pages/BowliversWorld';
import { ClipArtWorld } from './pages/ClipArtWorld';
import { PCH } from './pages/PHCK/PHCKH';
import { SomewhereElse } from './pages/SomewhereElse';
import { TACOH } from './pages/TACO/TACOH';
import { XANM } from './pages/XANM/XANM';
import { Main } from './components/Main';
import CursorProvider from './providers/CursorProvider';
import ToolbarProvider from './providers/ToolbarProvider';
import { BFH } from './pages/BFH';
import ExecProvider from './providers/ExecProvider';
import { FITP } from './pages/FITP';
import { VUT } from './pages/VUT';
import { PCFM } from './pages/PHCK/PHCKFM';
import { CNNF } from './pages/CNN/CNNF';
import { XANMI } from './pages/XANM/XANMI';
import { TACOM } from './pages/TACO/TACOM';
import { TACOF } from './pages/TACO/TACOF';
import { TACOB } from './pages/TACO/TACOB';
import { TACOG } from './pages/TACO/TACOG';
import { WTROKH } from './pages/WTROK/WTROKH';
import { WTROKS } from './pages/WTROK/WTROKS';
import { WTROKP } from './pages/WTROK/WTROKP';
import { WTROKT } from './pages/WTROK/WTROKT';
import { WTROKB } from './pages/WTROK/WTROKB';
import { WTROKI } from './pages/WTROK/WTROKI';
import { CNNH } from './pages/CNN/CNNH';
import { WTROKA } from './pages/WTROK/WTROKA';
import { CNNT } from './pages/CNN/CNNT';
import { CNN0 } from './pages/CNN/CNN0';
import { WTROK0 } from './pages/WTROK/WTROK0';
import { TROK0 } from './pages/TROK/TROK0';
import { TROKH } from './pages/TROK/TROKH';
import { TROKN } from './pages/TROK/TROKN';
import { TROKWTD } from './pages/TROK/TROKWTD';
import { TROKV } from './pages/TROK/TROKV';
import { TROKC } from './pages/TROK/TROKC';
import { TROKL } from './pages/TROK/TROKL';
import { TROKW } from './pages/TROK/TROKW';
import { TACO0 } from './pages/TACO/TACO0';
import { CNNFM } from './pages/CNN/CNNFM';
import { WTROKFM } from './pages/WTROK/WTROKFM';
import PlayerProvider from './providers/PlayerProvider';
import { TACOI } from './pages/TACO/TACOI';
import { TACOA } from './pages/TACO/TACOA';
import { SMTHNG } from './pages/SMTHNG';

export function App() {
    return (
        <ExecProvider value={{}}>
            <BrowserRouter>
                <PlayerProvider>
                    <CursorProvider value={{}}>
                        <ToolbarProvider>
                            <Routes>
                                <Route index element={<Main />} />
                                <Route path="/tripleoaks/*" element={<TROK0 /> }>
                                    <Route path='' element={<TROKH /> } />
                                    <Route path='news' element={<TROKN /> } />
                                    <Route path='wtd' element={<TROKWTD /> } />
                                    <Route path='history' element={<TROKV /> } />
                                    <Route path='construction' element={<TROKC /> } />
                                    <Route path='lost' element={<TROKL /> } />
                                    <Route path='what' element={<TROKW /> } />
                                    <Route path='found' element={<ClipArtWorld />} />
                                </Route>
                                <Route path="/gouch" element={<Gouch /> } />
                                <Route path="/bowliver" element={<BowliversWorld />} />
                                <Route path="/found" element={<ClipArtWorld />} />
                                <Route path="/cnn/*" element={<CNN0 />}>
                                    <Route path="" element={<CNNH />} />
                                    <Route path="testimonials" element={<CNNT />} />
                                    <Route path="forums/:boardId" element={<CNNF />} />
                                    <Route path="forums/:boardId/:topicId" element={<CNNF />} />
                                </Route>=
                                <Route path="/phrankscranks" element={<PCH />} />
                                <Route path="/thecomedyshow" element={<PCFM />} />
                                <Route path="/somewhere" element={<SomewhereElse />} />
                                <Route path='/tacobongo/*' element={<TACO0 />}>
                                    <Route path="" element={<TACOH />} />
                                    <Route path="menu" element={<TACOM />} />
                                    <Route path="findus" element={<TACOF />} />
                                    <Route path="meetbongo" element={<TACOB />} />
                                    <Route path="sweepstakes" element={<TACOA />} />
                                </Route>
                                <Route path='/ringringring' element={<WTROKFM />} />
                                <Route path="/wtrok/*" element={<WTROK0 /> }>                            
                                    <Route path="" element={<WTROKH />} />
                                    <Route path="about" element={<WTROKA />} />
                                    <Route path="sweepstakes" element={<WTROKS />} />
                                    <Route path="music" element={<WTROKP />} />
                                    <Route path="airtimes" element={<WTROKT />} />
                                    <Route path="bowling" element={<WTROKB />} />
                                    <Route path="transcript" element={<WTROKI />} />
                                </Route>
                                <Route path="/xtremeanime" element={<XANM />} />
                                <Route path="/omgitbfghbb" element={<BFH />} />
                                <Route path="/fitp" element={<FITP />} />
                                <Route path="/isekai" element={<XANMI />} />
                                <Route path="/vault" element={<VUT /> } />
                                <Route path="/radicaltruthchaserz" element={<CNNFM />} />
                                <Route path="/something" element={<SMTHNG />} />
                            </Routes>
                        </ToolbarProvider>
                    </CursorProvider>
                </PlayerProvider>
            </BrowserRouter>
        </ExecProvider>
    );
}